import posthog from "posthog-js";

// PostHog flag for the "my details" email-capture experiment.
// Active variant "test" shows the email-only design and make first/last name optional.
// "Control" keeps the existing design + required names.
export const MY_DETAILS_TEST_FLAG = "my_details_test";

export const MY_DETAILS_TEST = {
  id: MY_DETAILS_TEST_FLAG,
  variant: "test",
} as const;

/**
 * Non-React predicate that reads the resolved flag variant from the posthog-js
 * singleton. Used to make `requiredFieldsBySlug` flag-aware from non-React
 * callers (abandoned-cart routing, prefilled-field validation). Mirrors the
 * `inABTestGroup` helper in `useFlowNavigationContext` but without a hook.
 */
export const inABTestGroupFromSingleton = (flag: string): boolean =>
  posthog?.getFeatureFlag?.(flag) === "test";
